import { OpenpayErrorMessages } from 'src/utils/cards/openpayErrors';

export function getOpenPayErrorMessage(errorCode: number) {
  return OpenpayErrorMessages[errorCode]
    ? OpenpayErrorMessages[errorCode] + ` (cod. ${errorCode})`
    : `Ocurrió un error desconocido (cod. ${errorCode}). Por favor, intenta nuevamente.`;
}
